export class AccountingEntryResponse {
	end: number;
	records: AccountingEntryRecordResponse[];
	start: number;
	total: number;
}

export class AccountingEntryRecordResponse {
	company: number;
	creationDate: number;
	currencyType: number;
	date: number;
	description: string;
	editable: boolean;
	entries: AccountingEntryDataResponse[];
	generated: boolean;
	id: number;
	initial: boolean;
	module: string;
	number: number;
	total: number;
}

export class AccountingEntryDataResponse {
	account: number;
	accountData: AccountingEntryAccountResponse;
	credit: number;
	debit: number;
	id: number;
	itemId: number;
	taxes: number;
}

export class AccountingEntryAccountResponse {
	balance: number;
	deletable: boolean;
	displayId: string;
	id: number;
	name: string;
}

export class AccountingEntryUpdateRequest {
	description: string;
	entries: EntryUpdateRequest[] = [];
}

export class EntryUpdateRequest {
	account: number;
	entryId: number;
}